<template>
  <div class="icon-tooltip">
    <Popper :placement="placement" :trigger="trigger"><span><i :class="`icon icon-${icon} icon-tooltip__icon`"></i></span> <template v-slot:popover><slot></slot></template></Popper>
  </div>
</template>

<script>
import Popper from '@/components/Popper';

export default {
  name: 'IconTooltip',
  props: {
    icon: {
      type: String,
      default: 'question-circle'
    },
    placement: {
      type: String,
      default: 'auto'
    },
    trigger: {
      type: String,
      default: 'hover'
    }
  },
  components: {
    Popper
  }
};
</script>

<style lang="scss" scoped>
/**
 * Icon Tooltip
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Mostly used for question mark tooltip info
 * @since 2021-08-31
**/

$component: 'icon-tooltip';

.#{$component} {
  display: inline-block;
  @include margin-left(map-get($spacers, 1));
  cursor: pointer;
  color: $text-muted;
  font-size: inherit;

  &__icon {
    transform: scale(1.4) translateY(-0.020rem);
    vertical-align: middle;
  }

  ::v-deep .popper-wrapper {
    display: inline-block;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
